import { render, staticRenderFns } from "./Proceedings.vue?vue&type=template&id=0f48c7b3&scoped=true"
import script from "./Proceedings.vue?vue&type=script&lang=js"
export * from "./Proceedings.vue?vue&type=script&lang=js"
import style0 from "./Proceedings.vue?vue&type=style&index=0&id=0f48c7b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48c7b3",
  null
  
)

export default component.exports